export default __webpack_public_path__ + "static/media/member_card_blue.6aea1816.png";